import { FormEvent, useState } from "react";

interface EditDialogProps {
  source: string;
  translation: string;
  onCancel: () => void;
  onSave: (translation: string) => void;
}

export function EditDialog({
  source,
  translation,
  onCancel,
  onSave
}: EditDialogProps) {
  const [value, setValue] = useState(translation);

  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (value.trim()) onSave(value.trim());
  };

  return (
    <div className="dialog-backdrop" role="presentation" onMouseDown={onCancel}>
      <form
        className="dialog-card edit-dialog"
        onSubmit={submit}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="dialog-heading">
          <div>
            <span className="eyebrow">BLOCK EDITOR</span>
            <h2>校对这段译文</h2>
          </div>
          <button type="button" className="icon-button" onClick={onCancel}>
            ×
          </button>
        </div>
        <label>
          英文原文
          <div className="source-preview">{source}</div>
        </label>
        <label>
          中文译文
          <textarea
            autoFocus
            rows={8}
            value={value}
            onChange={(event) => setValue(event.target.value)}
          />
        </label>
        <div className="dialog-actions">
          <button type="button" className="secondary-button" onClick={onCancel}>
            取消
          </button>
          <button className="primary-button" type="submit" disabled={!value.trim()}>
            保存修改
          </button>
        </div>
      </form>
    </div>
  );
}
